import {useContext, useState} from "react";
import axios from "axios";
import Button from "./Button";
import Modal from "./Modal";
import {ColumnGrid, GridRow} from "./ColumnGrid";
import TextInput from "./TextInput";
import IconButton from "./IconButton";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {TemplateContext} from "../pages/MapTemplateEditor";

import config from '../config.json';

const LegendItemCreator = () => {
    const { template, setTemplate } = useContext(TemplateContext);
    const [ showModal, setShowModal ] = useState(false);

    const [ name, setName ] = useState();
    const [ color, setColor ] = useState();
    const [ hidden, setHidden ] = useState();

    const create = async () => {
        setShowModal(false);

        template.legend.push({ name, color, hidden: hidden === 'on' });
        setTemplate(template);
    };

    const footer = (
        <div style={{ display: "flex", gap: "20px" }}>
            <Button color="#40b319" onClick={create} content="Create"/>
            <Button color="#c20a0a" onClick={() => setShowModal(false)} content="Cancel"/>
        </div>
    );

    return (
        <>
            <Modal
                header="New Legend Item"
                footer={footer}
                show={showModal}
                onClose={() => setShowModal(false)}>
                <ColumnGrid columns="1fr 1fr">
                    <GridRow>
                        <span>Name</span>
                        <TextInput onChange={e => setName(e.target.value)}/>
                    </GridRow>
                    <GridRow>
                        <span>Color</span>
                        <input type="color" onChange={e => setColor(e.target.value)}/>
                    </GridRow>
                    <GridRow>
                        <span>Hidden</span>
                        <div>
                            <input type="checkbox" onChange={e => setHidden(e.target.value)} style={{ margin: 0, height: '2em', width: '2em' }}/>
                        </div>
                    </GridRow>
                </ColumnGrid>
            </Modal>
            <IconButton color="transparent" icon={faPlus} onClick={() => setShowModal(true)}/>
        </>
    );
}

export default LegendItemCreator;
